import React from 'react'

const GithubRibbon = () => {
  return (
    <a className="github-fork-ribbon left-bottom fixed" href="https://github.com/yashmantri20/MERNG-QuotesForAll-Client" target="_blank" rel="noopener noreferrer" data-ribbon="Fork me on GitHub" title="Fork me on GitHub">Fork me on GitHub</a>
  )
}

export default GithubRibbon
